import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/cycle-api';

import { useSwrRequestKeysToMutateFromContext } from '../../../../hooks/useSwrRequestKeysToMutateFromContext';

import { mutateDataAfterDeletingItem } from '../../../../helpers/swrMutateUtils';
import { mergeTwoArraysRemovingDuplicates } from '../../../../helpers/mergeTwoArraysRemovingDuplicates';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const ArchiveCycleModal = ({
    id,
    name,
    requestKeysToMutate: _requestKeysToMutate,
    onDeleteSuccess,
    onClose,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const {
        requestKeysToMutate: { cycles: requestKeysToMutateFromContext },
    } = useSwrRequestKeysToMutateFromContext();

    const handleDelete = async () => {
        try {
            setIsLoading(true);

            await client.delete(API.ROUTES.cycle.cycle + id + '/');

            const requestKeysToMutate = mergeTwoArraysRemovingDuplicates(
                _requestKeysToMutate,
                requestKeysToMutateFromContext
            );
            void mutateDataAfterDeletingItem({ id, requestKeysToMutate });

            onDeleteSuccess && onDeleteSuccess();

            onClose();
        } catch (e) {
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.status });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ConfirmDeletionModalPattern
            title="Archive Cycle?"
            handleDelete={handleDelete}
            onClose={onClose}
            isLoading={isLoading}
            confirmationTextStart="You are about to archive"
            confirmationTextEnd="are you sure you’d like to continue? This will archive the cycle and stages."
            entityName={`${name},`}
            variant="secondary"
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            buttonsSize="md"
            customConfirmButtonText="Yes, Archive"
        />
    );
};

export default ArchiveCycleModal;
